import { Directive, ElementRef, AfterViewInit, Renderer2, OnInit, Input, AfterContentInit } from '@angular/core';

@Directive({
  selector: '[appPreLoading]'
})
export class PreLoadingDirective implements OnInit {
  @Input('src') src: any;

  constructor(private elemRef: ElementRef, private renderer: Renderer2) { }

  ngOnInit() {
    this.renderer.setAttribute(this.elemRef.nativeElement, 'src', 'assets/images/everlon-portal-loader.gif');

    const image = new Image();
    image.onload = this.imageLoaded.bind(this);
    image.src = this.src;
  }

  imageLoaded() {
    this.renderer.setAttribute(this.elemRef.nativeElement, 'src', this.src);
  }

}
